import { jsx as _jsx } from "react/jsx-runtime";
import { ChakraProvider } from '@chakra-ui/react';
import { ColorModeProvider } from './providerMode';
import { systemTheme } from './theme';
export function ThemeProvider(props) {
    return (_jsx(ChakraProvider, { value: systemTheme, children: _jsx(ColorModeProvider, { ...props, enableSystem: false }) }));
}
//# sourceMappingURL=provider.js.map